export default {
  nav: {
    home: 'Home',
    about: 'About Us',
    services: 'Services',
    portfolio: 'Portfolio',
    contact: 'Contact',
  },
  hero: {
    slides: {
      marketing: {
        title: 'Digital Marketing Excellence',
        description: 'Transform your business with data-driven marketing strategies that deliver measurable results and maximize your ROI',
        cta: 'Start Growing Today'
      },
      webdesign: {
        title: 'Professional Web Design',
        description: 'Create stunning, responsive websites that captivate your audience and convert visitors into loyal customers',
        cta: 'Get Your Website'
      },
      socialmedia: {
        title: 'Social Media Marketing',
        description: 'Dominate all major social platforms with engaging content and strategic campaigns that build your brand presence',
        cta: 'Boost Your Presence'
      },
      googleads: {
        title: 'Google Ads Partner',
        description: 'Certified Google Partner delivering high-performance ad campaigns that reach your target audience at the perfect moment',
        cta: 'Launch Your Campaign'
      },
      facebookads: {
        title: 'Facebook Ads Expert',
        description: 'Meta Business Partner creating powerful Facebook and Instagram ad campaigns that drive engagement and sales',
        cta: 'Start Advertising'
      },
      consulting: {
        title: 'Strategic Consulting',
        description: 'Expert guidance across all social platforms to optimize your digital strategy and achieve sustainable growth',
        cta: 'Get Expert Advice'
      }
    },
    learnMore: 'Learn More',
  },
  about: {
    title: 'About Axloweb',
    subtitle: 'Your Digital Success Partner',
    description: 'We are a leading digital marketing agency in Santa Rosa, California, specializing in comprehensive online solutions. With certifications as Google Partner and Facebook Business Partner, we deliver exceptional results for businesses of all sizes.',
    mission: 'To empower businesses with innovative digital marketing strategies that drive growth, increase visibility, and maximize ROI through cutting-edge technology and creative excellence.',
    vision: 'To be the most trusted digital marketing partner in Northern California, recognized for transforming businesses through data-driven strategies and exceptional client service.',
    values: 'Excellence in every project, transparency and honesty, innovation and creativity, client success first, and continuous improvement.',
  },
  services: {
    title: 'Our Services',
    subtitle: 'Comprehensive Digital Solutions Tailored to Your Business Needs',
    marketing: {
      title: 'Digital Marketing',
      description: 'Complete digital marketing strategies including SEO, content marketing, email campaigns, and analytics to grow your online presence.',
      features: {
        0: 'SEO Optimization',
        1: 'Content Marketing',
        2: 'Email Campaigns',
        3: 'Analytics & Reporting'
      }
    },
    webDesign: {
      title: 'Web Design',
      description: 'Custom, responsive websites built with modern technologies that represent your brand perfectly and convert visitors.',
      features: {
        0: 'Responsive Design',
        1: 'Modern UI/UX',
        2: 'Fast Loading',
        3: 'Mobile Optimized'
      }
    },
    socialMedia: {
      title: 'Social Media Marketing',
      description: 'Strategic social media management across all major platforms to engage your audience and build brand presence.',
      features: {
        0: 'Content Creation',
        1: 'Community Management',
        2: 'Influencer Marketing',
        3: 'Social Analytics'
      }
    },
    googleAds: {
      title: 'Google Ads',
      description: 'Certified Google Partner creating high-performance ad campaigns that maximize ROI and reach your target audience.',
      features: {
        0: 'Search Ads',
        1: 'Display Ads',
        2: 'Shopping Ads',
        3: 'Video Ads'
      }
    },
    facebookAds: {
      title: 'Facebook Ads',
      description: 'Meta Business Partner delivering powerful Facebook and Instagram advertising campaigns that drive results.',
      features: {
        0: 'Facebook Ads',
        1: 'Instagram Ads',
        2: 'Audience Targeting',
        3: 'Conversion Tracking'
      }
    },
    consulting: {
      title: 'Consulting',
      description: 'Professional consulting services for all social media platforms with actionable insights to improve your digital presence.',
      features: {
        0: 'Strategy Planning',
        1: 'Platform Analysis',
        2: 'Performance Audit',
        3: 'Growth Roadmap'
      }
    }
  },
  portfolio: {
    title: 'Our Portfolio',
    subtitle: 'Explore Our Success Stories and Recent Projects',
    viewProject: 'View Project',
    projects: {
      fotosyvideo: {
        title: 'Fotos y Video Santa Rosa',
        description: 'Professional photography and videography services website with stunning portfolio galleries and online booking system.'
      },
      imagenprinting: {
        title: 'Imagen Printing',
        description: 'Complete printing services platform featuring product catalogs, custom order forms, and instant quote calculator.'
      },
      latinoofertasqr: {
        title: 'Latino Ofertas QR',
        description: 'Innovative QR code-based deals platform connecting local businesses with Latino community through digital coupons.'
      },
      latinoofertasmarket: {
        title: 'Latino Ofertas Market',
        description: 'Online marketplace featuring exclusive deals and promotions for the Latino community with integrated shopping cart.'
      },
      latinoofertasmagazine: {
        title: 'Latino Ofertas Magazine',
        description: 'Digital magazine platform showcasing community news, business features, and special offers with engaging content.'
      },
      kaespinoza: {
        title: 'K&A Espinoza Concrete',
        description: 'Professional concrete services website with project galleries, service descriptions, and instant quote request forms.'
      },
      storkmovers: {
        title: 'Stork Movers LLC',
        description: 'Professional moving services website with instant quotes, service area coverage, and customer testimonials.'
      },
      luisramosea: {
        title: 'Luis Ramos EA',
        description: 'Tax relief and IRS representation specialist website helping clients resolve tax problems with professional consultation services.'
      }
    }
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Let\'s Start Your Digital Transformation Journey Together',
    form: {
      name: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      company: 'Company Name',
      service: 'Service Interested',
      message: 'Your Message',
      submit: 'Send Message',
      sending: 'Sending...',
      success: 'Message sent successfully! We\'ll contact you soon.',
      error: 'Error sending message. Please try again.'
    },
    info: {
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      hours: 'Business Hours',
      hoursValue: 'Monday - Friday: 9:00 AM - 6:00 PM'
    }
  },
  footer: {
    description: 'Professional digital marketing agency in Santa Rosa, California. Google Partner and Facebook Business Partner delivering exceptional results.',
    quickLinks: 'Quick Links',
    services: 'Services',
    followUs: 'Follow Us',
    copyright: '© 2024 Axloweb. All rights reserved.',
    poweredBy: 'Powered by Readdy'
  }
};
